/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect } from 'react';
import {
	LeadingActions,
	SwipeableListItem,
	SwipeAction,
	TrailingActions,
	Type as ListType,
} from 'react-swipeable-list';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, Button, message as toaster } from 'antd';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useQueryParams } from 'hooks';
import { GetFullName } from 'utils';
import { InvoiceCardSwipe } from './InvoiceCard';
import { Image, Text, Flex } from 'atoms';
import {
	setBrandCheckList,
	saveInvoice,
	getInvoices,
	getReceivedInvoices,
	clearInvoice,
} from 'store/invoiceSlice';
import { ClearConfirmation } from 'components/pages/collection';
import DelegateAvatar from 'assets/user-delegate.svg';
import * as styled from './InvoiceCardWrap.style';
import { AR } from 'utils/constants';

const {
	BillBackSwipe,
	ClearSwipe,
	DetailContainer,
	SendBack,
	InvoiceBox,
	InvoiceCardContainer,
	InvoiceContainer,
} = styled;

const leadingActions = ({
	data,
	_clearRef,
	toggleState,
	makeColor,
	getClearConfirmation,
	getSameStoreInvoices,
	clearTheInvoice,
}) => {
	const handleClear = () => {
		makeColor();
		const { myInvoices = [], receivedInvoices = [] } = getSameStoreInvoices(data);

		if (myInvoices.length + receivedInvoices.length > 1) {
			getClearConfirmation();

			return false;
		}

		return clearTheInvoice(data, true);
	};

	const hasPending =
		data?.status?.toLowerCase() !== 'Pending'.toLowerCase() &&
		!data?.verified_by_cashier_id &&
		!data?.verified_by_segregator_id;

	return (
		<LeadingActions>
			<SwipeAction onClick={hasPending && !toggleState[0] ? handleClear : () => makeColor()}>
				<ClearSwipe ref={_clearRef} opacity={hasPending ? 1 : 0}>
					Clear
				</ClearSwipe>
			</SwipeAction>
		</LeadingActions>
	);
};

const trailingActions = ({
	data,
	dispatch,
	salesmanId,
	_billBackRef,
	toggleState,
	makeColor,
	getSameStoreInvoices,
	redirectToAmortization,
}) => {
	const handleBillBack = () => {
		makeColor();
		const { myInvoices = [], receivedInvoices = [] } = getSameStoreInvoices(data);

		if (myInvoices.length + receivedInvoices.length > 1) {
			toaster.info(`This store has multiple outstanding invoices,
			Redirecting you to amortization screen.`);

			setTimeout(() => {
				redirectToAmortization();
			}, 2000);

			return false;
		}

		// const formValues = {
		// 	previousStatus: 'Pending',
		// 	status: 'Bill Back',
		// 	payment: [],
		// };

		/**
		 * New payload for amortization
		 */
		const formValues = {
			previousStatus: 'Pending',
			status: 'Bill Back',
			invoices: [
				{
					id: data?.id,
					invoice_status_marked_by_salesman: 'Bill Back',
					remarks_from_salesman: '',
					reason_from_salesman: null,
					cash_limit_allowed: data?.cash_limit_allowed,
					store_cash_limit_allowed: data?.store_cash_limit_allowed,
				},
			],
			payments: {
				cash: {
					payment_type: 'Cash',
				},
				cheque: [],
				neft: [],
				upi: [],
			},
		};

		return dispatch(saveInvoice(data?.id, formValues, {})).then(() => {
			dispatch(getInvoices(salesmanId));
			dispatch(getReceivedInvoices(salesmanId));
		});
	};

	const hasPending = data?.status?.toLowerCase() === 'Pending'.toLowerCase();

	return (
		<TrailingActions>
			<SwipeAction
				onClick={hasPending && !toggleState[0] ? handleBillBack : () => makeColor()}
			>
				<BillBackSwipe ref={_billBackRef} opacity={hasPending ? 1 : 0}>
					Invoice Returned
				</BillBackSwipe>
			</SwipeAction>
		</TrailingActions>
	);
};

const SE = 'swipe-clear';
const SBB = 'swipe-bill-back';

export function InvoiceSwipeWrapper({
	invoice,
	isReceived = false,
	reAssigningInvoice = () => null,
}) {
	const dispatch = useDispatch();
	const { salesmanId = undefined } = useQueryParams();
	const _billBackRef = useRef(null);
	const _clearRef = useRef(null);
	const swipeRef = useRef(null);
	const { me = {} } = useSelector((state) => state.user);
	const { brandCheckList, isInvoiceOpen } = useSelector((state) => state.invoice);
	const { invoiceDate } = useSelector((state) => state.app);
	const { filteredInvoices = [], filteredReceivedInvoices = [] } = useSelector(
		(state) => state.invoice
	);
	const toggleState = useState(false);
	const [showClearConfirmation, setShowClearConfirmation] = useState(false);
	const history = useHistory();

	function makeColor() {
		const matrix = new window.WebKitCSSMatrix(swipeRef?.current?.listElement?.style?.transform);

		if (invoice?.status === 'Bill Back') {
			swipeRef?.current?.wrapperElement?.classList?.add(SE);
		}
		if (invoice?.status === 'Pending') {
			swipeRef?.current?.wrapperElement?.classList?.add(SBB);
		}
		if (matrix?.m41 === 0) {
			swipeRef?.current?.wrapperElement?.classList?.remove(SE, SBB);
		}

		if (swipeRef?.current?.left > 0 && invoice?.status === 'Pending') {
			_clearRef?.current?.click();
		}

		if (
			swipeRef?.current?.left < 0 &&
			(invoice?.status === 'Bill Back' || invoice?.status === 'No Bill Back')
		) {
			_billBackRef?.current?.click();
		}
	}

	useEffect(() => {
		// to close the swipe when panel about to open
		if (toggleState[0]) {
			_billBackRef?.current?.click();
			_clearRef?.current?.click();
			swipeRef?.current?.wrapperElement?.classList?.remove(SE, SBB);
		}

		return true;
	}, [toggleState]);

	useEffect(() => {
		// for clearing the state and colour when click on delegation
		if (invoice?.status === 'Pending') {
			_clearRef?.current?.click();
			toggleState[1](false);

			return true;
		}

		// for clearing the state and colour when click on delegation
		if (invoice?.status !== 'Pending') {
			_billBackRef?.current?.click();
			toggleState[1](false);

			return true;
		}

		return true;
	}, [invoice]);

	function getClearConfirmation() {
		setShowClearConfirmation(true);
	}

	const clearTheInvoice = (data, showMessage = false) => {
		/**
		 * Clear the swiped invoices and same store invoices
		 */
		dispatch(clearInvoice(data?.id, showMessage)).then(() => {
			dispatch(getInvoices(salesmanId));
			dispatch(getReceivedInvoices(salesmanId));
		});
	};

	function redirectToAmortization() {
		let salesman = '';

		if (me?.type === AR) {
			salesman = `&salesmanId=${salesmanId}`;
		}

		history.push({
			pathname: '/store',
			search: `?invoiceId=${invoice?.id}&storeId=${invoice?.store_id}${salesman}`,
		});
	}

	function getSameStoreInvoices(data) {
		/**
		 * Get same store invoices
		 */
		/**
		 * My invoices
		 */
		const myInvoices = filteredInvoices.filter((item) => item?.store_id === data?.store_id);

		/**
		 * Received invoices
		 */
		const receivedInvoices = filteredReceivedInvoices.filter(
			(item) => item?.store_id === data?.store_id
		);

		return {
			myInvoices: myInvoices || [],
			receivedInvoices: receivedInvoices || [],
		};
	}

	const handleClear = () => {
		makeColor();
		const { myInvoices = [], receivedInvoices = [] } = getSameStoreInvoices(invoice);

		/**
		 * on swipe clear invoice, clear the all same store invoices
		 */
		/**
		 * My invoices
		 */
		myInvoices.forEach((item, i) => {
			clearTheInvoice(item, i === 0);
		});
		/**
		 * Received invoices
		 */
		receivedInvoices.forEach((item, i) => {
			clearTheInvoice(item, i === 0);
		});
	};

	return (
		<SwipeableListItem
			fullSwipe={false}
			listType={ListType.IOS}
			leadingActions={leadingActions({
				data: invoice,
				toggleState,
				_clearRef,
				makeColor,
				getClearConfirmation,
				getSameStoreInvoices,
				clearTheInvoice,
			})}
			trailingActions={trailingActions({
				data: invoice,
				salesmanId,
				dispatch,
				toggleState,
				_billBackRef,
				makeColor,
				getSameStoreInvoices,
				redirectToAmortization,
			})}
			key={invoice.id}
			blockSwipe={toggleState[0]}
			onSwipeStart={makeColor}
			onSwipeEnd={() => {
				setTimeout(makeColor, 0);
			}}
			// onClick={makeColor}
			ref={swipeRef}
		>
			<InvoiceContainer isReceived={isReceived} className="invoice-card-outer">
				{/* {!deligationStatus ? (
					<InvoiceCardContainer>
						<InvoiceCardSwipe data={invoice} toggleState={toggleState} />
					</InvoiceCardContainer>
				) : (
					invoice?.status === 'Pending' && (
						<InvoiceCardContainer>
							<InvoiceCardSwipe
								data={invoice}
								showArrow={false}
								toggleState={toggleState}
							/>
						</InvoiceCardContainer>
					)
				)} */}
				<InvoiceCardContainer>
					<InvoiceCardSwipe data={invoice} toggleState={toggleState} />
				</InvoiceCardContainer>
			</InvoiceContainer>
			<ClearConfirmation
				visible={showClearConfirmation}
				onClose={() => {
					makeColor();
					setShowClearConfirmation(false);
				}}
				onClear={handleClear}
				infoText="Are you sure want to clear the invoices? this will clear all invoices from this same store"
			/>
		</SwipeableListItem>
	);
}

InvoiceSwipeWrapper.propTypes = {
	invoice: PropTypes.shape({
		id: PropTypes.number,
		status: PropTypes.string,
		source_salesman_first_name: PropTypes.string,
		source_salesman_last_name: PropTypes.string,
		source_verified_by_segregator: PropTypes.number,
		store_id: PropTypes.number,
	}),
	isReceived: PropTypes.bool,
	reAssigningInvoice: PropTypes.func,
};
